















































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import jwtDecode from 'jwt-decode';

import { insideProviderIframe } from '@/utils/providerIframe';
import segmentIo, {
  TRACKING_DEBUGGER_STORAGE_KEY,
  shouldShowTrackingDebugger,
  trackingDebuggerIsActive
} from '@/utils/segment.io';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import WalletIcon from '@/components/icons/WalletOutline.vue';
import PlusCircleIcon from '@/components/icons/PlusCircle.vue';
import NameIcon from '@/componentsV2/atoms/NameIcon/NameIcon.vue';
import Picture from '@/components/atoms/Picture/Picture.vue';

import AuthMenuItem from './AuthMenuItem.vue';

import { getGroupById } from '@/router';
import APIService from '@/api';
import SignUpService from '@/api/SingupService';
import ChangeUserType from '@/api/ChangeUserType';
import { isRootUser } from '@/utils/auth';
import eventBus from '@/utils/eventBus';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import flagKeys from '@/constants/flagKeys';
import { removeMerchantMeetingOboardingState } from '@/router/router-utils';
import { getShowOnboardingCallBanner } from '@/utils/onboardingCall';

@Component({
  components: {
    Picture,
    AuthMenuItem,
    NameIcon,
    WalletIcon,
    PlusCircleIcon,
    Typography
  }
})
export default class AuthMenuDropdown extends Vue {
  @Prop(Boolean) readonly viewOnly: boolean | undefined;
  @Prop() notificationMenu?: any;

  trackingDebuggerIsActive = trackingDebuggerIsActive();

  loading: boolean = false;

  user: any = null;
  businesses = [];

  signUpService = new SignUpService();
  tokenService = new ChangeUserType();
  info: any = null;

  get tPrefix() {
    return 'menus.topbar.profileMenuDrop';
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get getFlags() {
    return this.$store.getters['flags/getFlags'];
  }

  get showLogoutButton() {
    return !insideProviderIframe();
  }

  get showWhatsNew() {
    return this.getFlags.includes(flagKeys.whatIsNew);
  }

  get showOnboardingCallBanner() {
    return getShowOnboardingCallBanner();
  }

  get navbarMenu() {
    if (isRootUser()) {
      return [];
    }

    const group = getGroupById('auth-menu');
    if (!group) {
      return [];
    }

    return group.getVisibleRoutes();
  }

  get tokenSuperAdminMail() {
    const token = localStorage.getItem(
      `${window.location.host}-${APIService.SUPER_ADMIN}`
    );

    return jwtDecode(token).extraInfo.mail;
  }

  get shouldShowTrackingDebuggerButton() {
    return shouldShowTrackingDebugger();
  }

  @Watch('businessInfo')
  getUser() {
    this.user = this.businessInfo ? this.businessInfo.loggedInManager : null;
  }

  handleTrackingDebugger() {
    if (!this.shouldShowTrackingDebuggerButton) return;

    const state = !this.trackingDebuggerIsActive;

    this.trackingDebuggerIsActive = state;
    localStorage.setItem(TRACKING_DEBUGGER_STORAGE_KEY, JSON.stringify(state));
    if (state)
      segmentIo.identifyBusiness({
        ...this.businessInfo
      });
  }

  async getUserInfoFlagsData() {
    const userInfoResponse = await this.signUpService.verifyIfEmailExists(
      this.user.mail
    );

    if (userInfoResponse.status === 200) {
      this.info = userInfoResponse;
    }
  }

  logout() {
    APIService.resetCredentials();
    removeMerchantMeetingOboardingState();
  }

  openWhatIsNew() {
    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        componentToRender: 'whatIsNewModal',
        hideCancelButton: false,
        icon: '',
        mobilePositionBottom: true,
        mobileFullScreen: false
      })
    );
  }

  async personalAccount() {
    if (this.loading) return;

    try {
      this.loading = true;

      const response = await this.tokenService.changeToken();
      if (!response.data) {
        this.$notification(
          'Whoops! Something went wrong when switching to your personal wallet.',
          'error'
        );

        return;
      }

      document.cookie = `wallet=${response.data.access_token}; domain=.${
        process.env.VUE_APP_SWITCH_ACCOUNT_TOKEN_DOMAIN
      };`;

      if (response.data.access_token) {
        window.open(
          `${process.env.VUE_APP_WALLET_URL}/validate-token`,
          '_self'
        );
      }
    } finally {
      this.loading = false;
    }
  }

  createWallet() {
    this.personalAccount();
  }

  created() {
    if (isRootUser()) {
      this.user = {
        fullname: 'Super Admin',
        mail: this.tokenSuperAdminMail
      };
    } else {
      this.getUser();
      this.getUserInfoFlagsData();
    }
  }
}
